module.exports = __webpack_public_path__ + "components/outside-promo-page/static/app-card-surf-9caf8f1a4b0c7eaf0ec6645e9e40cbc1.webp";